import React from 'react'
import getConfig from 'next/config'

import { style } from '../../../components/Common/Index.style'
import { no160Style } from '../../../components/Article/No160.style'
import Page from '../../../components/Page/Page'
import PageHeader from '../../../components/PageHeader/PageHeader'
import Content from '../../../components/Content/Content'
import SectionTitle from '../../../components/SectioinTitle'
import BackBtn from '../../../components/Common/BackBtn'
import BreadCrumb from '../../../components/Breadcrumbs/Breadcrumbs'

const { publicRuntimeConfig } = getConfig()
const basePath = publicRuntimeConfig.basePath

const pageTitle = '新潟県のシンボル | 新潟県民だより'

const Home = () => {
  return (
    <Page title={pageTitle}>
      <PageHeader pageTitle="特集" />
      <SectionTitle sectionTitle="新潟県のシンボル" />
      <Content css={style.content}>
        <BreadCrumb
          lists={[
            {
              name: "HOME",
              path: "/"
            },
            {
              name: "2022秋号 No.160 目次",
              path: "/no160"
            },
            {
              name: "特集"
            }
          ]}
        />

        <img
          src={`${basePath}/no160/img/1-1.png`}
          alt="翡翠「県の石」へ"
          css={style.img(0)}
        />
        
        <h3 css={style.subTitle01}>ヒスイってどんな石？</h3>
        
        <p>石の色がカワセミ（翡翠）の羽の色に似ていることから、カワセミの漢字（翡翠）をあてて、中国でヒスイと呼ばれたのが名前の由来。翡翠の二文字はカワセミの雄と雌をそれぞれ表している。</p>
        
        <img
          src={`${basePath}/no160/img/1-2.png`}
          alt="カワセミ"
          css={style.img(500, "15px 0 0 0")}
        />
        <p css={style.imgCap}>カワセミ</p>
        
        <ul>
          <li>▪美しく色鮮やかな宝石の一種。</li>
          <li>▪色は、有名な緑の他に、白・薄紫・青・黒など。</li>
          <li>▪堅く、強靭。ダイヤモンドよりも壊れにくい。</li>
          <li>▪2016年に「日本の石」（国石）に選定された。</li>
        </ul>
        
        <img
          src={`${basePath}/no160/img/1-3.png`}
          alt="県職員の新花（しんか）さん　新花さんの息子カタル（潟留）くん"
          css={style.img(400)}
        />
        
        <h3 css={style.subTitle01}>どうして県の石になるの？</h3>
        <h4 css={style.subTitle02}>世界最古の歴史！</h4>
        <p>国内の遺跡から出土したヒスイは<span css={[no160Style.hisuiStrong,style.emphasisWeight]}>全て糸魚川産</span>であることが判明しています。なかでも糸魚川市大角地（おがくち）遺跡（縄文時代前期）からは、<span css={[no160Style.hisuiStrong,style.emphasisWeight]}>マヤ文明よりも古い</span>、世界最古のヒスイ加工品が発見されました。<br />
        糸魚川市のほか、村上・胎内・見附・長岡・柏崎・上越市などでもヒスイの装身具が出土し、また全国的にも<span css={[no160Style.hisuiStrong,style.emphasisWeight]}>北海道から沖縄県まで流通</span>したことが分かっています。ヒスイの加工品は、新潟県から日本全国に広がっており、<span css={[no160Style.hisuiStrong,style.emphasisWeight]}>最古級の日本海交易を示す</span>ものといえます。</p>
        
        <h4 css={style.subTitle02}>国内最大の産地！</h4>
        <p>国内で11か所あるヒスイ産地のうち、新潟県は最大の規模を誇るとともに、宝石の素材となる透明度が高い良質なヒスイが産出される唯一の産地です。</p>
        <p>糸魚川市の小滝川や青海川のヒスイ峡は国の天然記念物であり、ユネスコ世界ジオパークの構成資産にもなっています。</p>

        <p><span css={style.emphasisWeight}>このような、歴史的・文化的価値や独自性などから、「県の石」に指定されることが決まりました。</span></p>
        
        <p css={style.notetTxt}>「翡翠の『県の石』指定に係る検討委員会」で「県の石」とすることが妥当であるとされました。</p>
        
        <hr />
        
        <h3 css={style.subTitle01}>知っていますか？新潟県のシンボル</h3>
        
        <p css={style.catchTxt}>県の石&emsp;翡翠（ひすい）〔令和4年11月4日指定〕</p>
        <img
          src={`${basePath}/no160/img/2-1.png`}
          alt="翡翠の写真"
          css={style.img(500)}
        />
        
        <h4 css={style.subTitle02}>教えます！ヒスイのあれこれ</h4>
        
        <img
          src={`${basePath}/no160/img/2-2.png`}
          alt="竹之内 耕 館長"
          css={style.img(200, "15px 0 0 0")}
        />
        <p css={style.imgCap}>フォッサマグナミュージアム <br />竹之内 耕 館長</p>
        
        
        <h5 css={style.subTitle03}>ヒスイの誕生は約5億年前！</h5>
        
        <p>ヒスイは地上から何十キロも深い、地下深部のプレートが沈み込む場所で生まれた石で、その生成過程は日本列島誕生の一部を物語るものです。フォッサマグナがヒスイを生んだと勘違いされることもあるのですが、フォッサマグナは2,000万年前の出来事で、ヒスイが出来たのは5億年前。フォッサマグナができる随分前にヒスイは誕生しているのです。ただ、フォッサマグナが隆起して山を作ったとき、同時にヒスイを含む地層も地表に持ち上げられ、それが川によって削られ、ヒスイが露出しました。そういう意味では糸魚川産ヒスイとフォッサマグナとは関係が深い、とも言えますね。</p>
        
        <h5 css={style.subTitle03}>実は忘れられていた！？</h5>
        <p>糸魚川がヒスイの産地であることは長く忘れ去られていて、改めて発見されたのは昭和10年代です。きっかけは、糸魚川出身の文人・相馬御風（そうまぎょふう）が、「古事記」にある奴奈川姫（ぬなかわひめ）伝説や「万葉集」の「ぬなかわの底なる玉」という歌から糸魚川に産地があると想像し、地元の人に探索を依頼したことでした。</p>
        
        <h5 css={style.subTitle03}>ロマンと魅力がつまった石</h5>
        
        <p>ヒスイは古代の人々から大切にされた、彼らの精神世界を物語る石であり、歴史的なロマン、宝石としての魅力など、見る人の興味によって、さまざまな切り口で楽しめる石だと思います。</p>
        
        <h5 css={style.subTitle03}>産地の保護・保全を</h5>
        
        <p>糸魚川市のヒスイ峡と呼ばれるヒスイの産地では、巨大なヒスイの原石を見ることができます。ヒスイ峡は国の天然記念物に指定されていて、岩石を採取することはできません。また、<span css={style.emphasisWeight}>海岸でヒスイ探しをする際は、拾うのは手のひらサイズの石のみにして、大きな石は拾わないでください。</span>貴重な「県の石」・「日本の石」であるヒスイを未来へ伝えていけるよう、ひとり一人がマナーを守り、産地の保護・保全に努めましょう。</p>
        
        <br />
        
        
        <h4 css={style.subTitle02}>私のお気に入りヒスイ／海岸でヒスイ発見!?</h4>
        <h5 css={style.subTitle03}>ヒスイ探しのガイド&emsp;エマ・ロングホーンさん</h5>
        
        <img
          src={`${basePath}/no160/img/2-3.png`}
          alt="エマ・ロングホーンさん"
          css={style.img(200)}
        />
        
        <p>ヒスイは誰でも探すことができる宝石だということが魅力。海が荒れた2日後、海岸に打ち上がりやすいです。探しに行く前に、機会があればヒスイの標本を手に取って細かく見て、ヒスイの特徴を覚えていきましょう。貴重なヒスイが身近にある糸魚川の豊かな自然が大好きなので、皆さんにもこの自然を大切にしながら楽しんでほしいです。</p>
        
        <img
          src={`${basePath}/no160/img/2-4.png`}
          alt="私のお気に入りヒスイ"
          css={style.img(500, "15px 0 0 0")}
        />
        <p css={style.imgCap}>押上海岸の波打ち際で拾った小さなヒスイです。波に磨かれてすべすべで、見れば見るほどかわいいですね。</p>
        
        
        <h5 css={style.subTitle03}>ヒスイ探しのガイド&emsp;古見 浩さん</h5>
        <img
          src={`${basePath}/no160/img/2-5.png`}
          alt="古見 浩さん"
          css={style.img(200)}
        />
        
        <p>ヒスイは角ばっていて、他の石よりも重みがあります。水に濡れているヒスイは青白く輝いて見え、乾いたときには表面にキラキラした結晶が見えるのが特徴です。また、乾いても他の石と違って表面がスベスベしています。ヒスイは緑や白以外に黒やグレーの石もあって、どれもとてもきれいです。海岸に通ううちに、ヒスイの「顔」が分かるようになりますよ。</p>
        
        <img
          src={`${basePath}/no160/img/2-6.png`}
          alt="私のお気に入りヒスイ"
          css={style.img(500, "15px 0 0 0")}
        />
        <p css={style.imgCap}>ツアーガイドでヒスイを説明するとき、見本としてお見せする相棒です。ヒスイらしい白×緑の色が気に入っています。</p>
        
        <br />
        
        <h4 css={style.subTitle02}>フォッサマグナミュージアム イベント情報</h4>
        <h5 css={style.subTitle03}>みんなのヒスイ展 11月30日（水）まで</h5>
        
        <p>市民の皆さんなどが所有する糸魚川産のヒスイを展示しています。思い出が詰まった秘蔵のヒスイに出会えるかも。</p>
        
        <img
          src={`${basePath}/no160/img/2-7.png`}
          alt="みんなのヒスイ展"
          css={style.img(212)}
        />
        
        <p>フォッサマグナミュージアム（糸魚川市大字一ノ宮）&emsp;電話：<a href="tel:025-553-1880">025-553-1880</a></p>
        
        <br />
        
        <p css={style.catchTxt}>県の花&emsp;チューリップ〔昭和38年8月23日制定〕</p>
        <img
          src={`${basePath}/no160/img/3-1.png`}
          alt="チューリップの写真"
          css={style.img(500, "15px 0 0 0")}
        />
        <p css={style.imgCap}>撮影：中村 脩</p>
        
        <p>切り花の出荷量は平成4年から<span css={style.emphasisWeight}>全国トップ</span>。最大の産地は新潟市で、球根栽培が盛んな胎内市、五泉市でも生産しています。県が開発したオリジナル品種もあります。</p> 
        
        <h4 css={style.subTitle02}>楽しみが広がる♪色・形のバリエーション</h4>
        <p css={style.notetTxt}>※いずれも県開発品種</p>
        
        <img
          src={`${basePath}/no160/img/3-2.png`}
          alt="雪の華（フリンジ咲き）"
          css={style.img(200, "15px 0 0 0")}
        />
        <p css={style.imgCap}>雪の華（フリンジ咲き）</p>
        
        <img
          src={`${basePath}/no160/img/3-3.png`}
          alt="越黄冠（ユリ咲き）"
          css={style.img(200, "15px 0 0 0")}
        />
        <p css={style.imgCap}>越黄冠（ユリ咲き）</p>
        
        <img
          src={`${basePath}/no160/img/3-4.png`}
          alt="恋心（パーロット咲き）"
          css={style.img(200, "15px 0 0 0")}
        />
        <p css={style.imgCap}>恋心（パーロット咲き）</p>
        
        <h4 css={style.subTitle02}>TIPS&emsp;チューリップの花びらは何枚？</h4>
        
        <p>花びらは6枚あるように見えますが、実は外側の3枚は「がく」。内側の3枚より丈夫にできており、花びらを支えています。花びらと同じように色づき、虫をおびき寄せて受粉を促す役割もあります。</p>
        
        <br />
        <p css={style.catchTxt}>県の木&emsp;雪椿〔昭和41年8月27日制定〕</p>
        <img
          src={`${basePath}/no160/img/3-5.png`}
          alt="雪椿の写真"
          css={style.img(500, "15px 0 0 0")}
        />
        <p css={style.imgCap}>撮影：中村 脩</p>
        
        <p>日本海側の雪の多い地帯に自生し、雪の中でも緑を見せる生命力があります。<br />
          雪椿が初めて発見され、命名の地でもある阿賀町では、オイルやハンドクリーム、ジェラートなど、雪椿由来の商品も販売されています。</p>
        
        <br />
        <p css={style.catchTxt}>県の鳥&emsp;朱鷺（とき）〔昭和40年9月13日指定〕</p>
        <img
          src={`${basePath}/no160/img/3-6.png`}
          alt="朱鷺の写真"
          css={style.img(500, "15px 0 0 0")}
        />
        <p css={style.imgCap}>提供：新潟県佐渡トキ保護センター</p>
        
        <p>国の特別天然記念物。日本産の朱鷺は絶滅してしまいましたが、中国から贈られた2羽の人工繁殖から始まり、現在では毎年数十羽のヒナが育ち、佐渡で放鳥が続けられています。</p>
        
        <h4 css={style.subTitle02}>TIPS&emsp;ヒナは「朱鷺色」？</h4>
        
        <p>翼や尾羽などの裏側の「朱鷺色」と呼ばれるオレンジがかったピンク色が美しい朱鷺ですが、ヒナは全身ほぼ灰色で、翼の裏面は淡黄色、顔は黄色です。</p>
        
        <img
          src={`${basePath}/no160/img/3-7.png`}
          alt="朱鷺のヒナ"
          css={style.img(250, "15px 0 0 0")}
        />
        <p css={style.imgCap}>朱鷺のヒナ</p>
        
        <img
          src={`${basePath}/no160/img/3-8.png`}
          alt="新潟県宣伝課長「トッキッキ」"
          css={style.img(200, "15px 0 0 0")}
        />
        <p css={style.imgCap}>新潟県宣伝課長「トッキッキ」</p>
        
        
        <br />
        <p css={style.catchTxt}>県の草花&emsp;雪割草〔平成20年3月1日指定〕</p>
        <img
          src={`${basePath}/no160/img/3-9.png`}
          alt="雪割草の写真"
          css={style.img(500, "15px 0 0 0")}
        />
        <p css={style.imgCap}>撮影：中村 脩</p>
        
        <p>新潟県は雪割草の国内最大の自生地。一時は絶滅も危惧されましたが、保護活動によって守り育てられています。<br />毎年、県庁の森で植栽会を行っています。</p>
        
        <br />
        <p css={style.catchTxt}>県の鑑賞魚&emsp;錦鯉〔平成29年5月5日指定〕</p>
        <p css={style.notetTxt}>※一般的には「観賞魚」と表記しますが、錦鯉が美術的な価値があるという意味を含め、「鑑賞」としています。</p>
        <img
          src={`${basePath}/no160/img/3-10.png`}
          alt="錦鯉の写真"
          css={style.img(500, "15px 0 0 0")}
        />
        <p css={style.imgCap}>提供：鱗光</p>
        
        <p>新潟県は錦鯉の発祥地であり、関連する事業者数も全国トップ。新潟が誇る文化の一つであり、世界各国にも愛好者がいるほどです。<br />輸出額はなんと約27億円！（令和3年）</p>
        
        <h4 css={style.subTitle02}>世界錦鯉サミット併催イベント<br />クールジャパンEXPO in NIIGATA 開催</h4>
        
        <p>入場無料</p>
        <p>新潟が誇るクールジャパンコンテンツ（錦鯉、グルメ、日本酒、漫画・アニメ、伝統工芸品など）を見て、食べて、買って楽しめます。</p>
        
        <ul>
          <li>▪開催日&emsp;11月5日（土）、6日（日）10：00〜17：00</li>
          <li>▪会場&emsp;朱鷺メッセ</li>
          <li>▪内容&emsp;錦鯉展示、飲食販売、物産販売、ステージイベント など</li>
        </ul>
        
        <p>イベント内容について詳しくは
          <a
            href="https://cje-niigata.jp/"
            target="_blank"
            rel="noreferrer"
          >
            <span>こちら</span>
          </a>
        </p>
        
        <p>問い合わせ&emsp;政策企画課&emsp;電話：<a href="tel:025-280-5269">025-280-5269</a></p>
        
        
        
        <hr />
        <h3 css={style.subTitle01}>翡翠、県の石へ</h3>
        
        <img
          src={`${basePath}/no160/img/3-11.png`}
          alt="新潟県知事　花角英世"
          css={style.img(250)}
        />
        
        <p>この度、翡翠を新たな県のシンボルとして「県の石」に指定することが決まりました。本県で産出された翡翠は、その美しさから、縄文時代から古墳時代にかけて宝飾品等として全国で広く利用されていたこと、本県産地は現在、全国で唯一、国の天然記念物に指定されていることなど、歴史的にも文化的にも大きな価値があると認識しております。また、翡翠は糸魚川のジオパーク内で保全され、地元の教育素材としても、また、持続可能な観光資源としても利活用されているところです。県の誇るべきシンボルがまた一つ増えるこの機会に、翡翠のみならず、県の花 チューリップ、県の鳥 朱鷺、県の木 雪椿、県の草花 雪割草、県の鑑賞魚 錦鯉、それぞれの魅力を改めて広く知っていただき、より多くの方に親しんでいただきたいと思います。<br />現在、翡翠、錦鯉などの県のシンボルをはじめ、豊かな自然や食文化、日本酒、世界遺産登録を目指す「佐渡島の金山」、スノーリゾートなど、様々な新潟ブランドが輝き始めています。新潟が住む場所、働く場所、挑戦する場所、訪れる場所として「選ばれる地」となるよう、これらの新潟ブランドを磨き上げ、その魅力を効果的に発信するとともに、県民の皆様が地域の魅力に誇りを持ち、前向きに発信できる環境づくりを進めてまいります。</p>
        
        <p>新潟県知事&emsp;花角英世</p>

        <BackBtn href={"/no160"} />
      </Content>
    </Page>
  )
}
export default Home
